<template>
    <div>
        <div class="orc-vert-limit-header">
            <h1 class="text-2xl mb-6"><i class="el-icon-date mr-3"></i>Agenda</h1>
        </div>
        <div class="w-full py-4 mb-16 relative" v-if="events && events.length > 0">
            <div class="orc-vert-limit-header">
                <div>
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" v-for="event in events" :key="event.id">
                            <el-card shadow="hover" class="card pb-8">
                                <div class="flex mb-8 leading-none">
                                    <div class="p-4 bg-lightblue text-main rounded mr-2 font-medium flex justify-center items-center"><span>{{ moment(event.whenDate).format('DD') }}</span></div>
                                    <div class="pt-2"><span class="text-lg">{{ event.title }}</span> <br> <span class="text-gray-600 text-xs"> {{ moment(event.whenDate).format('MMMM') }}</span></div>
                                </div>

                                <content-displayer :current="event.description"></content-displayer>

                                <div class="absolute bottom-0 left-0 right-0 w-full">
                                    <footer class="py-4 pr-4 flex justify-end">
                                        <div class="float-right">
                                            <span class="text-gray-600 text-sm mr-2"><i class="el-icon-date mr-1 text-gray-600"></i>{{ moment(event.whenDate).format('DD-MM-YYYY') }}</span>
                                            <span class="text-gray-600 text-sm"><i class="el-icon-time mr-1 text-gray-600"></i> {{ moment(event.whenTime).format('HH:mm')}}</span>
                                        </div>
                                    </footer>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="orc-vert-limit-header mb-16">
                Geen evenementen om weer te geven.
            </div>
        </div>
    </div>
</template>

<script>
    import ContentDisplayer from "../content/ContentDisplayer";
    export default {
        name: "Agenda",
        props: ['branchId'],
        components: {
            ContentDisplayer
        },
        watch: {
            branchId: function (newVal, val) {
                this.getEvents()
            }
        },
        data() {
            return {
                activeName: '1',
                events: this.getEvents()
            }
        },
        methods: {
            getEvents() {
                this.$http.get(`events?branch=${this.branchId}`).then((response) => {
                    this.events = response.data
                }).catch(function (error) {
                    console.log(error)
                })
            }
        }
    }
</script>

<style scoped>
    .card {
        min-height: 400px;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/agenda/Agenda.vue